export default __webpack_public_path__ + "static/media/emoji-grec.57093b14.svg";